import { ReactNode, useEffect } from "react"
import { CloseIcon } from "../../icons/close"
import './styles.scss'
import clsx from "clsx"

interface Props {
    title: string
    children: ReactNode
    showButtons?: boolean
    headerGreen?: boolean,
    headerOrange?: boolean
    close: () => void
}

export function Alert(props: Props) {
    const { children, close } = props
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                close();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [close]);


    return (
        <div id="alert" className="alertAdd">
            <div className="alertElements">
                <div className="modal">
                    <div className={clsx("popupHeader pl-5 pr-5", { 'bg-white': !props.headerGreen, 'bg-green text-white': props.headerGreen, 'bg-orange text-white': props.headerOrange })}>
                        <h5 className={clsx("heading", { 'text-white': (props.headerGreen || props.headerOrange) })}>{props.title}</h5>
                        <button
                            onClick={close}
                        >
                            <CloseIcon />
                        </button>
                    </div>
                    <div className='alert-content'>
                        <div className="pb-3">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}